export default function StartNode() {
    return (
        <div className="milestone-container">
            <div className="node start-node"></div>
            <div className="date-left">Present</div>
            <div className="edge"></div>
        </div>
    )
}